'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.getCUMajorList = getCUMajorList;
var GET_CUMAJOR_LIST = 'major/cumajor_types/GET_CUMAJOR_LIST';
var GET_CUMAJOR_LIST_SUCCESS = 'major/cumajor_types/GET_CUMAJOR_LIST_SUCCESS';
var GET_CUMAJOR_LIST_FAIL = 'major/cumajor_types/GET_CUMAJOR_LIST_FAIL';

var initialState = {
    loading: false,
    cumajorList: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case GET_CUMAJOR_LIST:
            return _extends({}, state, {
                loading: true
            });
        case GET_CUMAJOR_LIST_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                cumajorList: action.result.data.data,
                loading: false
            });
        case GET_CUMAJOR_LIST_FAIL:
            return _extends({}, state, {
                loading: false
            });
        default:
            return state;
    }
}
function getCUMajorList(jobClassCode) {
    return {
        types: [GET_CUMAJOR_LIST, GET_CUMAJOR_LIST_SUCCESS, GET_CUMAJOR_LIST_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/major_type/' + jobClassCode);
            }

            return promise;
        }()
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/major/cumajorTypes.js
// module id = 490
// module chunks = 0